import { Alerts } from "components/alerts";
import { IdleTimeoutHandler } from "components/idle-timeout";
import { NavbarPortalProvider } from "components/layout/navbar-portal-context";
import { SidebarLayout } from "components/layout/sidebar-layout";
import { NgReminders } from "components/ng-reminders/ng-reminders";
import { Responsive } from "components/responsive";
import { ReminderProvider } from "contexts/reminder";
import { TimerProvider } from "contexts/timer-context";
import React from "react";
import { AutoReload } from "./auto-reload";
import { PreviewUrlHandler } from "./preview-url-handler";
import { UserChangedReload } from "./user-changed-reload";

interface NgContainerProps {
    children: React.ReactNode;
}

export const NgContainer: React.FC<NgContainerProps> = props => {
    return (
        <NavbarPortalProvider>
            <Responsive />
            <AutoReload />
            <UserChangedReload />
            <PreviewUrlHandler />
            <Alerts />
            <IdleTimeoutHandler />
            <TimerProvider>
                <ReminderProvider>
                    <NgReminders />
                    <SidebarLayout>{props.children}</SidebarLayout>
                </ReminderProvider>
            </TimerProvider>
        </NavbarPortalProvider>
    );
};
